import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';

/**
 * Este componente es un "guardián".
 * Recibe { children } que es el componente que queremos proteger (ej. UserProfile)
 */
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  // 1. Si estamos "cargando" (verificando si hay un token),
  //    mostramos un "Cargando..." para evitar saltos visuales.
  if (loading) {
    // Puedes reemplazar esto con un componente "Spinner" si tienes uno
    return <div>Cargando...</div>;
  }

  // 2. Si no estamos cargando Y no hay usuario,
  //    redirigimos a /login.
  if (!user) {
    // 'replace' evita que el usuario pueda "volver" a la página protegida
    // usando el botón de atrás del navegador.
    return <Navigate to="/login" replace />;
  }

  // 3. Si no estamos cargando Y SÍ hay usuario,
  //    mostramos el componente hijo (la página protegida).
  return children;
};

export default ProtectedRoute;